import { render } from "./CEditMagazine.vue?vue&type=template&id=265b0794"
import script from "./CEditMagazine.vue?vue&type=script&lang=js"
export * from "./CEditMagazine.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__